import {ChartOptions, TooltipItem} from "chart.js";

export const FinanceDashboardPieChartOptions: ChartOptions = {
 responsive: true,
   plugins: {
     tooltip: {
       callbacks: {
         label: (tooltipItem: TooltipItem<'pie'>) => {
           const originalValue = tooltipItem.dataset.data[tooltipItem.dataIndex];
           return `${tooltipItem.label}: ${originalValue}`;
         }
       }
     },
     datalabels: {
       display: 'auto',
       font: {
         weight: 'bolder'
       },
       anchor: 'end',
       align:  'end',
       formatter: (value, context) => {
         const originalValue = context.dataset.data[context.dataIndex];
         return value === originalValue ? value : `${originalValue}`;
       }
     }
   },
   scales: {
     y: {
       display: false
     },
   },
   layout: {
     padding: {
       top: 8,
       bottom: 20,
       left: 8,
       right: 8
     }
   }
};

export const FinanceDashboardBarChartOptions: ChartOptions = {
  scales: {
    x: {
      display: true
    },
    y: {
      display: true
    },
  },
  plugins: {
    datalabels: {
      anchor: 'end',
      align: 'end',
      font: {
        size: 10,
        weight: 'bolder'
      },
      display: 'auto',
    },
    legend: {
      onClick: (e) => {
        const mouseEvent = (e.native as MouseEvent);
        mouseEvent.stopPropagation();
      }
    }
  }
};

export const SubmitToPieChartColorOptionsArray = [
  '#134220',
  '#71C08A',
  '#C77F02',
  '#EDBF6B',
  '#0289C7',
  '#6BC4ED'
];

export const TravelTypePieChartColorOptionsArray = [
  '#a2798f',
  '#e5fffa',
  '#509c87',
  '#004242',
  '#989898',
  '#6fa2d0',
  '#4c516d',
  '#eac086',
  '#708090',
  '#eb9c1c',
  '#a3c1ad',
  '#5f9ea0',
  '#aec6cf',
  '#cbb87b',
  '#073763',
  '#9f8a01',
  '#30bea4',
  '#49796b',
  '#b3503a'
];

export const ExternalTravelTypePieChartColorOptionsArray = [
  '#b36a76',
  '#6d9bb3',
  '#6fa886',
  '#b3a94f',
  '#b38c66',
  '#866494',
  '#5c8db3',
  '#b36c82',
  '#7fb49a',
  '#b3a64f',
  '#8da877',
  '#b37d4f',
  '#b36a55',
  '#976393',
  '#7aa3b3',
  '#8da96f',
  '#975fa3',
  '#b36d7a',
  '#9763b3'
];
